import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import MainLayout from "../components/layout/MainLayout";
import Breadcrumbs from "../components/common/Breadcrumbs";
import PHQList from "../pages/Phase-04/PHQ/PHQList";

import {
    fetchPhqAssessments,
    deletePhqAssessment,
    setCurrentPhqAssessment,
} from "../store/slices/phqAssessmentsSlice";

const PHQ = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { phqAssessments, isLoading } = useSelector(
        (state) => state.phqAssessments
    );

    // Load all PHQ assessments on page load
    useEffect(() => {
        dispatch(fetchPhqAssessments());
    }, [dispatch]);

    // Add new assessment
    const handleAdd = () => navigate("/phase04/phq/add");

    // Edit assessment
    const handleEdit = (id) => {
        const assessment = phqAssessments.find((a) => a.id === id);
        dispatch(setCurrentPhqAssessment(assessment));
        navigate(`/phase04/phq/edit/${id}`);
    };

    // Delete assessment
    const handleDelete = (id) => {
        dispatch(deletePhqAssessment(id));
    };

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />

                <div className="card">
                    <div className="card-body p-0">
                        <PHQList
                            assessments={phqAssessments}
                            isLoading={isLoading}
                            onAdd={handleAdd}
                            onEdit={handleEdit}
                            onDelete={handleDelete}
                        />
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default PHQ;
